import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7890f980&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=7890f980&scoped=true&lang=sass&"
import style1 from "./index.vue?vue&type=style&index=1&id=7890f980&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7890f980",
  null
  
)

export default component.exports